import React, { useState } from "react";
import Button from "../Button/Button";
import Input from "../Input/Input";
import { Hit, Stand, Split, Double } from "../../utils/Icons";
import "./sidebar.css";
import { SidebarProps } from "../../GameTypes/game.type";
import INR from "../../assets/images/INR.webp";
import DepositButton from "../DepostiButton/DepositButton";
import useCounterStore from "../../store/store";
import { handleChangeNum } from "../../utils/helpers";

const Sidebar: React.FC<SidebarProps> = ({
  handleStand,
  handleHit,
  handleDoubleDown,
  hasDoubledDown,
  playerCards,
  showInsurance,
  handleAcceptInsurance,
  handleDeclineInsurance,
  disableActions,
  handleSplit,
  gameButtonClicked,
  handleGameButtonClick,
}) => {
  const { isMovieMode, setWalletAmt, walletAmt, setBetAmt, isSound } =
    useCounterStore((state) => state);

  console.log("walletAmt", walletAmt);

  const [betAmount, setBetAmount] = useState<number>(0);

  const handleChange = (e: any) => {
    const { value } = e.target;

    let checkVal = isNaN(Number(value));

    if (!checkVal) {
      setBetAmount(Number(value));
      setBetAmt(value);
    } else {
      if (checkVal) {
        setBetAmount(0.0);
      }
    }
  };

  const canSplit =
    playerCards[0].length === 2 &&
    playerCards[0][0].value === playerCards[0][1].value;

  return (
    <div className="game-sidebar" style={{ position: "relative" }}>
      <div className="game-sidebar-container">
        <div className="game-bet-layout">
          <div className="game-bet-wrapper">
            <div className="game-bet-label">
              <label>Play</label>
              {/* <span>0.00 USD</span> */}
            </div>

            <div className="betInputField">
              <div className="betInputInner">
                <img src={INR} alt="INR" width={"20px"} />
                <Input
                  type="text"
                  placeholder="0.00"
                  value={betAmount}
                  onChange={(e) => handleChange(e)}
                />
              </div>

              <div className="game-bet-input-suffix-container">
                <button className="bet-suffix">
                  {/* <span>½</span> */}
                  1/2
                </button>
                <div className="game-bet-input-suffix-divider" />
                <button className="bet-suffix">2×</button>
              </div>
            </div>

            {/* <div className="game-bet-input-wrapper">
              <div className="game-bet-input-icon">🪙</div>
              <div className="game-bet-input">
                <Input type="text" placeholder="0.00" />
              </div>

              <div className="game-bet-input-suffix">
                <div className="game-bet-input-suffix-container">
                  <button className="bet-suffix">
                    <span>½</span>
                  </button>
                  <div className="game-bet-input-suffix-divider" />
                  <button className="bet-suffix">2×</button>
                </div>
              </div>
            </div> */}
          </div>
        </div>

        {showInsurance ? (
          <div className="insurance-layout">
            <div className="insurance-container">
              <p>Would you like insurance?</p>
              <Button onClick={handleAcceptInsurance} variant="bet">
                Accept Insurance
              </Button>
              <Button onClick={handleDeclineInsurance} variant="light">
                No Insurance
              </Button>
            </div>
          </div>
        ) : (
          <div className="game-sidebar-actions">
            <div className="game-sidebar-action-wrapper">
              <div className="game-sidebar-action-container">
                <Button
                  onClick={() => handleHit()}
                  variant="light"
                  disabled={disableActions || gameButtonClicked.hit}
                >
                  Hit <Hit />
                </Button>
                <Button
                  onClick={() => handleStand()}
                  variant="light"
                  disabled={
                    playerCards[0].length < 2 ||
                    gameButtonClicked.stand ||
                    disableActions
                  }
                >
                  Stand <Stand />
                </Button>
                <Button
                  onClick={handleSplit}
                  variant="light"
                  // disabled={true}
                  disabled={
                    disableActions || !canSplit || gameButtonClicked.split
                  }
                >
                  Split <Split />
                </Button>
                <Button
                  onClick={() => handleDoubleDown()}
                  variant="light"
                  disabled={
                    disableActions ||
                    !hasDoubledDown ||
                    gameButtonClicked.double ||
                    playerCards[0].length !== 2
                  }
                >
                  Double <Double />
                </Button>
              </div>

              <div className="bet-button-grid">
                <Button
                  onClick={handleGameButtonClick}
                  disabled={gameButtonClicked.play || betAmount === 0}
                  variant="bet"
                >
                  Play
                </Button>
              </div>
            </div>
          </div>
        )}


     <div className="depositBtnContainer flex justify-between items-center bottom-[20px] absolute w-full px-[15px] xs:max-w-full tab:max-w-[360px]">
          <span className="text-white text-[18px] transition-all duration-300 ease-in-out cursor-pointer font-bold">
            ₹{walletAmt > 0 ? walletAmt.toFixed(2) : 0}
          </span>

          <DepositButton />
        </div>
   
      </div>
    </div>
  );
};

export default Sidebar;
